"use client";
import { j as H } from "./jsx-runtime-CJ-St4mQ.mjs";
import { s as fe } from "./ChevronDownIcon-ALVrcZU5.mjs";
import { t as pe } from "./tv.config-BuYIgndg.mjs";
import V from "./Typography.js";
import * as o from "react";
import { c as Q, u as W } from "./useRenderElement-B8V3_e8R.mjs";
import { u as q } from "./useEventCallback-CjuAhyNz.mjs";
import { u as X } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as me } from "./useControlled-B2rPEZCb.mjs";
import { u as _ } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as he, T as G, t as ge, A as v } from "./useAnimationsFinished-DDpUuXkZ.mjs";
import { u as be, a as ye } from "./useOpenChangeComplete-CXAVaIGe.mjs";
import { u as xe } from "./useCompositeListItem-Dxy1vBYe.mjs";
import { u as B } from "./AccordionRootContext-BOaLElCp.mjs";
import { i as Y } from "./isElementDisabled-LIsdpGBj.mjs";
import { b as Z, e as ee, c as te, d as ne, H as Re, E as Ce } from "./composite-D7hKyvC5.mjs";
import { u as Ne } from "./useButton-CQeWQM5o.mjs";
import { s as ve } from "./event-CXjJudzK.mjs";
import { w as oe } from "./warn-BEDWsnVv.mjs";
import { u as Oe } from "./useOnMount-JHtE6teb.mjs";
function Se(t) {
  const {
    open: n,
    defaultOpen: r,
    onOpenChange: O,
    disabled: g
  } = t, a = n !== void 0, [p, T] = me({
    controlled: n,
    default: r,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: S,
    setMounted: b,
    transitionStatus: l
  } = be(p, !0, !0), [d, E] = o.useState(p), [{
    height: u,
    width: R
  }, I] = o.useState({
    height: void 0,
    width: void 0
  }), C = X(), [w, m] = o.useState(), k = w ?? C, [c, y] = o.useState(!1), [M, N] = o.useState(!1), P = o.useRef(null), x = o.useRef(null), D = o.useRef(null), e = o.useRef(null), i = he(e, !1), h = q(() => {
    const s = !p, f = e.current;
    x.current === "css-animation" && f != null && f.style.removeProperty("animation-name"), !c && !M && (x.current != null && x.current !== "css-animation" && !S && s && b(!0), x.current === "css-animation" && (!d && s && E(!0), !S && s && b(!0))), T(s), O(s), x.current === "none" && S && !s && b(!1);
  });
  return _(() => {
    a && x.current === "none" && !M && !p && b(!1);
  }, [a, M, p, n, b]), o.useMemo(() => ({
    abortControllerRef: P,
    animationTypeRef: x,
    disabled: g,
    handleTrigger: h,
    height: u,
    mounted: S,
    open: p,
    panelId: k,
    panelRef: e,
    runOnceAnimationsFinish: i,
    setDimensions: I,
    setHiddenUntilFound: y,
    setKeepMounted: N,
    setMounted: b,
    setOpen: T,
    setPanelIdState: m,
    setVisible: E,
    transitionDimensionRef: D,
    transitionStatus: l,
    visible: d,
    width: R
  }), [P, x, g, h, u, S, p, k, e, i, I, y, N, b, T, E, D, l, d, R]);
}
const L = /* @__PURE__ */ o.createContext(void 0);
process.env.NODE_ENV !== "production" && (L.displayName = "CollapsibleRootContext");
function re() {
  const t = o.useContext(L);
  if (t === void 0)
    throw new Error("Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>.");
  return t;
}
const K = /* @__PURE__ */ o.createContext(void 0);
process.env.NODE_ENV !== "production" && (K.displayName = "AccordionItemContext");
function z() {
  const t = o.useContext(K);
  if (t === void 0)
    throw new Error("Base UI: AccordionItemContext is missing. Accordion parts must be placed within <Accordion.Item>.");
  return t;
}
let U = function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = G.startingStyle] = "startingStyle", t[t.endingStyle = G.endingStyle] = "endingStyle", t;
}({}), Pe = /* @__PURE__ */ function(t) {
  return t.panelOpen = "data-panel-open", t;
}({});
const Ee = {
  [U.open]: ""
}, Ie = {
  [U.closed]: ""
}, we = {
  open(t) {
    return t ? {
      [Pe.panelOpen]: ""
    } : null;
  }
}, Ae = {
  open(t) {
    return t ? Ee : Ie;
  }
};
let Me = /* @__PURE__ */ function(t) {
  return t.index = "data-index", t.disabled = "data-disabled", t.open = "data-open", t;
}({});
const $ = {
  ...Ae,
  index: (t) => Number.isInteger(t) ? {
    [Me.index]: String(t)
  } : null,
  ...ge,
  value: () => null
}, ie = /* @__PURE__ */ o.forwardRef(function(n, r) {
  const {
    className: O,
    disabled: g = !1,
    onOpenChange: a,
    render: p,
    value: T,
    ...S
  } = n, {
    ref: b,
    index: l
  } = xe(), d = Q(r, b), {
    disabled: E,
    handleValueChange: u,
    state: R,
    value: I
  } = B(), C = T ?? l, w = g || E, m = o.useMemo(() => {
    if (!I)
      return !1;
    for (let i = 0; i < I.length; i += 1)
      if (I[i] === C)
        return !0;
    return !1;
  }, [I, C]), k = q((i) => {
    u(C, i), a == null || a(i);
  }), c = Se({
    open: m,
    onOpenChange: k,
    disabled: w
  }), y = o.useMemo(() => ({
    open: c.open,
    disabled: c.disabled,
    hidden: !c.mounted
  }), [c.open, c.disabled, c.mounted]), M = o.useMemo(() => ({
    ...c,
    onOpenChange: k,
    state: y,
    transitionStatus: c.transitionStatus
  }), [c, y, k]), N = o.useMemo(() => ({
    ...R,
    index: l,
    disabled: w,
    open: m
  }), [w, l, m, R]), [P, x] = o.useState(X()), D = o.useMemo(() => ({
    open: m,
    state: N,
    setTriggerId: x,
    triggerId: P
  }), [m, N, x, P]), e = W("div", n, {
    state: N,
    ref: d,
    props: S,
    customStyleHookMapping: $
  });
  return /* @__PURE__ */ H.jsx(L.Provider, {
    value: M,
    children: /* @__PURE__ */ H.jsx(K.Provider, {
      value: D,
      children: e
    })
  });
});
process.env.NODE_ENV !== "production" && (ie.displayName = "AccordionItem");
const se = /* @__PURE__ */ o.forwardRef(function(n, r) {
  const {
    render: O,
    className: g,
    ...a
  } = n, {
    state: p
  } = z();
  return W("h3", n, {
    state: p,
    ref: r,
    props: a,
    customStyleHookMapping: $
  });
});
process.env.NODE_ENV !== "production" && (se.displayName = "AccordionHeader");
const He = /* @__PURE__ */ new Set([Z, ee, te, ne, Re, Ce]);
function Te(t) {
  const {
    current: n
  } = t, r = [];
  for (let O = 0; O < n.length; O += 1) {
    const g = n[O];
    if (!Y(g)) {
      const a = g == null ? void 0 : g.querySelector('[type="button"]');
      Y(a) || r.push(a);
    }
  }
  return r;
}
const ae = /* @__PURE__ */ o.forwardRef(function(n, r) {
  const {
    disabled: O,
    className: g,
    id: a,
    render: p,
    nativeButton: T = !0,
    ...S
  } = n, {
    panelId: b,
    open: l,
    handleTrigger: d,
    disabled: E
  } = re(), u = O ?? E, {
    getButtonProps: R,
    buttonRef: I
  } = Ne({
    disabled: u,
    focusableWhenDisabled: !0,
    native: T
  }), {
    accordionItemRefs: C,
    direction: w,
    loop: m,
    orientation: k
  } = B(), c = w === "rtl", y = k === "horizontal", {
    state: M,
    setTriggerId: N,
    triggerId: P
  } = z();
  _(() => (a && N(a), () => {
    N(void 0);
  }), [a, N]);
  const x = o.useMemo(() => ({
    "aria-controls": l ? b : void 0,
    "aria-expanded": l,
    disabled: u,
    id: P,
    onClick: d,
    onKeyDown(e) {
      if (!He.has(e.key))
        return;
      ve(e);
      const i = Te(C), s = i.length - 1;
      let f = -1;
      const A = i.indexOf(e.target);
      function j() {
        m ? f = A + 1 > s ? 0 : A + 1 : f = Math.min(A + 1, s);
      }
      function F() {
        m ? f = A === 0 ? s : A - 1 : f = A - 1;
      }
      switch (e.key) {
        case Z:
          y || j();
          break;
        case ee:
          y || F();
          break;
        case te:
          y && (c ? F() : j());
          break;
        case ne:
          y && (c ? j() : F());
          break;
        case "Home":
          f = 0;
          break;
        case "End":
          f = s;
          break;
      }
      f > -1 && i[f].focus();
    }
  }), [C, u, d, P, y, c, m, l, b]);
  return W("button", n, {
    state: M,
    ref: [r, I],
    props: [x, S, R],
    customStyleHookMapping: we
  });
});
process.env.NODE_ENV !== "production" && (ae.displayName = "AccordionTrigger");
let ke = /* @__PURE__ */ function(t) {
  return t.disabled = "data-disabled", t.orientation = "data-orientation", t;
}({});
function De(t) {
  const {
    abortControllerRef: n,
    animationTypeRef: r,
    externalRef: O,
    height: g,
    hiddenUntilFound: a,
    keepMounted: p,
    id: T,
    mounted: S,
    onOpenChange: b,
    open: l,
    panelRef: d,
    runOnceAnimationsFinish: E,
    setDimensions: u,
    setMounted: R,
    setOpen: I,
    setVisible: C,
    transitionDimensionRef: w,
    visible: m,
    width: k
  } = t, c = o.useRef(!1), y = o.useRef(null), M = o.useRef(l), N = o.useRef(l), P = o.useMemo(() => r.current === "css-animation" ? !m : !l && !S, [l, S, m, r]), x = q((e) => {
    if (!e)
      return;
    if (r.current == null || w.current == null) {
      const s = getComputedStyle(e), f = s.animationName !== "none" && s.animationName !== "", A = s.transitionDuration !== "0s" && s.transitionDuration !== "";
      f && A ? process.env.NODE_ENV !== "production" && oe("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : s.animationName === "none" && s.transitionDuration !== "0s" ? r.current = "css-transition" : s.animationName !== "none" && s.transitionDuration === "0s" ? r.current = "css-animation" : r.current = "none", e.getAttribute(ke.orientation) === "horizontal" || s.transitionProperty.indexOf("width") > -1 ? w.current = "width" : w.current = "height";
    }
    if (r.current !== "css-transition")
      return;
    e.style.setProperty("display", "block", "important"), (g === void 0 || k === void 0) && (u({
      height: e.scrollHeight,
      width: e.scrollWidth
    }), e.style.removeProperty("display"), N.current && e.style.setProperty("transition-duration", "0s"));
    let i = -1, h = -1;
    return i = v.request(() => {
      N.current = !1, h = v.request(() => {
        setTimeout(() => {
          e.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      v.cancel(i), v.cancel(h);
    };
  }), D = Q(O, d, x);
  return _(() => {
    if (r.current !== "css-transition")
      return;
    const e = d.current;
    if (!e)
      return;
    let i = -1;
    if (n.current != null && (n.current.abort(), n.current = null), l)
      e.style.setProperty("display", "block", "important"), !N.current && !p && e.setAttribute(U.startingStyle, ""), u({
        height: e.scrollHeight,
        width: e.scrollWidth
      }), i = v.request(() => {
        e.style.removeProperty("display");
      });
    else {
      u({
        height: e.scrollHeight,
        width: e.scrollWidth
      }), n.current = new AbortController();
      const h = n.current.signal;
      let s = -1;
      const f = v.request(() => {
        s = v.request(() => {
          E(() => {
            u({
              height: 0,
              width: 0
            }), e.style.removeProperty("content-visibility"), e.style.removeProperty("display"), R(!1), n.current = null;
          }, h);
        });
      });
      return () => {
        v.cancel(f), v.cancel(s);
      };
    }
    return () => {
      v.cancel(i);
    };
  }, [n, r, a, p, S, l, d, E, u, R, w]), _(() => {
    if (r.current !== "css-animation")
      return;
    const e = d.current;
    e && (y.current = e.style.animationName || y.current, e.style.setProperty("animation-name", "none"), u({
      height: e.scrollHeight,
      width: e.scrollWidth
    }), !M.current && !c.current && e.style.removeProperty("animation-name"), l ? (n.current != null && (n.current.abort(), n.current = null), R(!0), C(!0)) : (n.current = new AbortController(), E(() => {
      R(!1), C(!1), n.current = null;
    }, n.current.signal)));
  }, [n, r, l, d, E, u, R, C, m]), Oe(() => {
    const e = v.request(() => {
      M.current = !1;
    });
    return () => v.cancel(e);
  }), _(() => {
    if (!a)
      return;
    const e = d.current;
    if (!e)
      return;
    let i = -1, h = -1;
    return l && c.current && (e.style.transitionDuration = "0s", u({
      height: e.scrollHeight,
      width: e.scrollWidth
    }), i = v.request(() => {
      c.current = !1, h = v.request(() => {
        setTimeout(() => {
          e.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      v.cancel(i), v.cancel(h);
    };
  }, [a, l, d, u]), _(() => {
    const e = d.current;
    e && a && P && (e.setAttribute("hidden", "until-found"), r.current === "css-transition" && e.setAttribute(U.startingStyle, ""));
  }, [a, P, r, d]), o.useEffect(function() {
    const i = d.current;
    if (!i)
      return;
    function h() {
      c.current = !0, I(!0), b(!0);
    }
    return i.addEventListener("beforematch", h), () => {
      i.removeEventListener("beforematch", h);
    };
  }, [b, d, I]), o.useMemo(() => ({
    props: {
      hidden: P,
      id: T,
      ref: D
    }
  }), [P, T, D]);
}
let J = /* @__PURE__ */ function(t) {
  return t.accordionPanelHeight = "--accordion-panel-height", t.accordionPanelWidth = "--accordion-panel-width", t;
}({});
const le = /* @__PURE__ */ o.forwardRef(function(n, r) {
  const {
    className: O,
    hiddenUntilFound: g,
    keepMounted: a,
    id: p,
    render: T,
    ...S
  } = n, {
    hiddenUntilFound: b,
    keepMounted: l
  } = B(), {
    abortControllerRef: d,
    animationTypeRef: E,
    height: u,
    mounted: R,
    onOpenChange: I,
    open: C,
    panelId: w,
    panelRef: m,
    runOnceAnimationsFinish: k,
    setDimensions: c,
    setHiddenUntilFound: y,
    setKeepMounted: M,
    setMounted: N,
    setOpen: P,
    setVisible: x,
    transitionDimensionRef: D,
    visible: e,
    width: i,
    setPanelIdState: h,
    transitionStatus: s
  } = re(), f = g ?? b, A = a ?? l;
  process.env.NODE_ENV !== "production" && _(() => {
    a === !1 && f && oe("The `keepMounted={false}` prop on a Accordion.Panel will be ignored when using `contextHiddenUntilFound` on the Panel or the Root since it requires the panel to remain mounted when closed.");
  }, [f, a]), _(() => {
    if (p)
      return h(p), () => {
        h(void 0);
      };
  }, [p, h]), _(() => {
    y(f);
  }, [y, f]), _(() => {
    M(A);
  }, [M, A]), ye({
    open: C && s === "idle",
    ref: m,
    onComplete() {
      C && c({
        width: void 0,
        height: void 0
      });
    }
  });
  const {
    props: j
  } = De({
    abortControllerRef: d,
    animationTypeRef: E,
    externalRef: r,
    height: u,
    hiddenUntilFound: f,
    id: p ?? w,
    keepMounted: A,
    mounted: R,
    onOpenChange: I,
    open: C,
    panelRef: m,
    runOnceAnimationsFinish: k,
    setDimensions: c,
    setMounted: N,
    setOpen: P,
    setVisible: x,
    transitionDimensionRef: D,
    visible: e,
    width: i
  }), {
    state: F,
    triggerId: ce
  } = z(), de = o.useMemo(() => ({
    ...F,
    transitionStatus: s
  }), [F, s]), ue = W("div", n, {
    state: de,
    ref: [r, m],
    props: [j, {
      "aria-labelledby": ce,
      role: "region",
      style: {
        [J.accordionPanelHeight]: u === void 0 ? "auto" : `${u}px`,
        [J.accordionPanelWidth]: i === void 0 ? "auto" : `${i}px`
      }
    }, S],
    customStyleHookMapping: $
  });
  return A || f || !A && R ? ue : null;
});
process.env.NODE_ENV !== "production" && (le.displayName = "AccordionPanel");
const _e = pe({
  slots: {
    rootClasses: "Accordion_Item border border-gray-200 shadow-md rounded-xl mb-3 last:mb-0  bg-white  data-[open]:pb-4 data-[open]:border-secondary-light transition-all duration-300 ease-out",
    buttonClasses: "Accordion_Button group flex w-full cursor-pointer items-center justify-between gap-4  text-left font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-800 px-6 py-4",
    titleClasses: "Accordion_Title text-base font-semi-bold ",
    accordionPanel: "accordion-panel h-[var(--accordion-panel-height)] overflow-hidden text-base text-gray-600 transition-[height] duration-300 ease-out data-[ending-style]:h-0 data-[starting-style]:h-0 px-6",
    indicatorClasses: "Accordion_Indicator size-6 shrink-0 transition-all duration-300 ease-out group-data-[panel-open]:scale-110 group-data-[panel-open]:rotate-180 text-primary-main"
  },
  variants: {
    expanded: {
      true: {
        buttonClasses: "pb-3",
        indicatorClasses: "rotate-180",
        accordionPanel: "",
        rootClasses: "pb-6"
      }
    }
  }
}), {
  rootClasses: Fe,
  buttonClasses: je,
  titleClasses: Ue,
  accordionPanel: We,
  indicatorClasses: Ve
} = _e(), qe = (t) => {
  const { title: n, description: r, subtitle: O, children: g, ...a } = t;
  return /* @__PURE__ */ H.jsxs(ie, { className: Fe({}), ...a, children: [
    /* @__PURE__ */ H.jsx(
      se,
      {
        render: (p) => /* @__PURE__ */ H.jsx("div", { ...p }),
        children: /* @__PURE__ */ H.jsxs(ae, { className: je({}), children: [
          /* @__PURE__ */ H.jsx(V, { className: Ue({}), children: n }),
          O && /* @__PURE__ */ H.jsx(V, { children: O }),
          /* @__PURE__ */ H.jsx(fe, { className: Ve({}) })
        ] })
      }
    ),
    /* @__PURE__ */ H.jsx(le, { className: We({}), children: /* @__PURE__ */ H.jsxs("div", { className: "pt-3", children: [
      r && /* @__PURE__ */ H.jsx(V, { variant: "h6", render: /* @__PURE__ */ H.jsx("span", {}), className: "text-lg", children: r }),
      g
    ] }) })
  ] });
};
qe.displayName = "AccordionItem";
export {
  qe as default
};
